module.exports = "<gmc-local-spinner></gmc-local-spinner><form ng-if=$ctrl.config payment-process-form config=$ctrl.config class=payment-form action=https://secure.platononline.com/payment/auth method=post style=display:none><button type=submit>Submit</button></form>";


//////////////////
// WEBPACK FOOTER
// ./app/states/payment-process/components/payment-process/payment-process.component.html
// module id = 968
// module chunks = 31